/* HFS kids sizing hub: builds the sticky left Contents nav from the page's
   section headings + the Shoe Finder block, with scroll-spy highlighting.
   No Find My Width tool. Runs only on the kids hub layout (.hfs-main + #hfs-toc). */
(function () {
  function init() {
    var toc = document.getElementById("hfs-toc");
    var main = document.querySelector(".hfs-main");
    if (!toc || !main || toc.dataset.hfsKidsNavReady === 'true') return;
    toc.dataset.hfsKidsNavReady = 'true';

    /* Pin the nav just below the real sticky header, auto-measured. */
    var hdr = document.querySelector(".section-header");
    var setStick = function () {
      if (hdr) document.documentElement.style.setProperty("--hfs-stick", (hdr.offsetHeight + 16) + "px");
    };
    setStick();
    window.addEventListener("resize", setStick, { passive: true });

    /* Short, friendly nav labels regardless of the exact heading wording. */
    function navLabel(text) {
      var t = text.toLowerCase();
      if (t.indexOf("width") > -1) return "Width chart";
      if (t.indexOf("size") > -1 || t.indexOf("length") > -1) return "Size chart";
      if (t.indexOf("measure") > -1) return "How to measure";
      return text.trim();
    }

    /* Collect sections: each chart heading, plus the Shoe Finder block. */
    var sections = [], i = 0;
    main.querySelectorAll(".hfs-kids-chart h2").forEach(function (h) {
      if (!h.id) h.id = "kids-sec-" + (i++);
      h.classList.add("hfs-anchor");
      h.setAttribute("tabindex", "-1"); /* focus target for the Contents links (GLB-28) */
      sections.push({ id: h.id, label: navLabel(h.textContent) });
    });
    var finder = document.getElementById("hfs-kids-finder");
    if (finder) {
      finder.classList.add("hfs-anchor");
      finder.setAttribute('tabindex', '-1');
      sections.push({ id: "hfs-kids-finder", label: "Shop kids' shoes" });
    }
    if (sections.length < 2) { toc.hidden = true; return; }

    var ul = toc.querySelector("ul");
    ul.textContent = ""; /* the page renders one link to hold the nav's height; rebuild the list */
    sections.forEach(function (sct) {
      var li = document.createElement("li"), a = document.createElement("a");
      a.href = "#" + sct.id; a.textContent = sct.label; a.setAttribute("data-target", sct.id);
      /* HFS a11y (GLB-28, same pattern as demand item c): scroll AND move focus to the section, via the shared
         helper in custom.js (reduced motion, sticky-header offset, hash update); native jump as fallback. */
      a.addEventListener("click", function (e) {
        if (typeof window.hfsJumpTo === "function") {
          if (window.hfsJumpTo(sct.id)) e.preventDefault();
          return;
        }
        var t = document.getElementById(sct.id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView();
        t.focus({ preventScroll: true });
        if (history.replaceState) history.replaceState(history.state, "", "#" + sct.id);
      });
      li.appendChild(a); ul.appendChild(li);
    });
    toc.hidden = false;
    toc.removeAttribute("data-hfs-pending"); /* sections/main-page.liquid held its space until now */

    var links = ul.querySelectorAll("a");
    function spy() {
      var stick = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--hfs-stick"), 10) || 130;
      var cur = sections[0].id;
      sections.forEach(function (sct) {
        var el = document.getElementById(sct.id);
        if (el && el.getBoundingClientRect().top <= stick + 6) cur = sct.id;
      });
      if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 2) cur = sections[sections.length - 1].id;
      links.forEach(function (a) {
        var active = a.getAttribute("data-target") === cur;
        a.classList.toggle("is-active", active);
        if (active) a.setAttribute("aria-current", "true");
        else a.removeAttribute("aria-current");
      });
    }
    window.addEventListener("scroll", spy, { passive: true });
    window.addEventListener("resize", spy, { passive: true });
    spy();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
